<div class="return-to-previous-page-container">
    <div
    (click)="returnToPreviousPage()"
    class="return-to-previous-page-container-btn">
    <mat-icon class="return-to-previous-page-container-btn-icon">cancel</mat-icon> Retourner
    </div>
</div>
